module.exports = __webpack_public_path__ + "img/csm__MG_8445_16af3de64b.0de30c17.jpg";